import { useEffect } from "react";
import type { GameState } from "../../domain/types/index.js";
import { bgmForState, syncGameBgm } from "./gameBgm.js";

export function useGameBgm(state: Pick<GameState, "screen" | "run" | "resolution">): void {
  const track = bgmForState(state);

  useEffect(() => {
    void syncGameBgm(track);
  }, [track]);

  useEffect(() => () => {
    void syncGameBgm(null);
  }, []);
}
